import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=1bd897ba&"
import script from "./Svg.vue?vue&type=script&lang=ts&"
export * from "./Svg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports